import React from 'react';
import Component from '../../components/Component';
import DbInfo from '../../dbinfo';
import * as Constants from '../../constants';
import Toolbar from '../../components/Toolbar';
import {Button, ButtonToolbar} from 'react-bootstrap';
import {RxForm, FormManager, FormField, FormRow, Multiform} from 'reactis-forms';
import {TextInput, TextArea, CKEditor, DatePicker, TimeInput, RadioList, FileUpload, ImageUpload, Select, Checkbox} from 'reactis-inputs';
import {actions as formactions} from 'reactis-forms';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {AlertWindow, ConfirmWindow} from 'reactis-modal';
import FormDB from '../../components/FormDB';
import {Loader, LoadingButton} from 'reactis-loader';
import ActionButton from '../../components/ActionButton';
import SaveButton from '../../components/SaveButton';
import DocumentTitle from 'react-document-title';
import NavBar from '../../components/NavBar';

@connect((state, props) => {
		return {
			form: state.forms.get('setting')
		};
	},
	(dispatch) => {
		return {actions: bindActionCreators(formactions, dispatch)};
	}, null, {withRef: true })
export default class Form extends FormDB {

	constructor(props, context) {
		super(props, context);

		this.api = {
			fetch: 'setting.fetch',
			save: 'setting.save'
		};

		this.changeEvent = 'setting.change';

		this.messages = {
			notfound: 'Nastavení nenalezeno!',
			saved: 'Nastavení bylo uloženo.'
		};


		this.schema = {
			invoice_address: {
				class: TextArea,
				label: 'Fakturační adresa',
				style: {height: 70}
			},
			invoice_ic: {
				class: TextArea,
				label: 'Identifikační čísla',
				style: {height: 70}
			},
			invoice_subtext: {
				class: TextArea,
				label: 'Text pod identifikačním číslem',
				style: {height: 70}
			},
			invoice_bank: {
				class: TextInput,
				label: 'Banka'
			},
			invoice_bank_number: {
				class: TextInput,
				label: 'Číslo účtu'
			},
			invoice_iban: {
				class: TextInput,
				label: 'IBAN'
			},
			invoice_footer: {
				class: TextArea,
				label: 'Patička faktury',
				style: {height: 70}
			},
			fio_api_account: {
				class: TextInput,
				label: 'FIO API účet'
			},
			fio_api_token: {
				class: TextInput,
				label: 'FIO API token'
			},
			invoice_sign: {
				class: ImageUpload,
				galleryPicker: false,
				label: 'Razítko fakturační'
			},
			sign_small: {
				class: ImageUpload,
				galleryPicker: false,
				label: 'Razítko TK'
			},
		};
		this.form = new FormManager(this.schema);
	}

	componentDidMount() {
		this.form.on('change', (key, value) => {
			this.changed = true;
		});
		super.componentDidMount();
	}

	load() {
		this.props.actions.load('setting', this.api.fetch).then(a => {
			this.changed = false;
			if (a.error && a.error.code == 404) {
				alert(this.messages.notfound);
			}
		});
	}

	getFormData() {
		return {...this.form.getValues().toJS()};
	}

	render() {

		const canEdit = true;
		const saveButton = <SaveButton
			disabled={!canEdit}
			loading={!!(this.props.form && this.props.form.get('saving'))}
			onClick={()=>this.save()}
		/>;

		const btns = <ButtonToolbar>
			{saveButton}
		</ButtonToolbar>;

		return (
			<div className="tdidocument">
				<DocumentTitle title="Nastavení" />
				<NavBar title="Nastavení" />
				<div className="panel" style={{paddingBottom: 0}}>
					<div style={{padding:20, position:'relative'}}>
						<Loader visible={!!(this.props.form && this.props.form.get('loading'))} />
						<RxForm ref="form" form={this.form} id="setting">
							<Toolbar title="Nastavení" buttons={btns} />
							<div className="row">
								<div className="col-md-10">
									<table className="form">
										<tbody>
										{Object.keys(this.schema).map((key) => {
											return <FormRow key={key} visible={this.schema[key].visible} name={key} labelWidth={240} />
										})}
										<FormRow className="buttons">
											{saveButton}
										</FormRow>
										</tbody>
									</table>
								</div>
							</div>
						</RxForm>
					</div>
				</div>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/containers/Setting/Setting.js